import common from "./common.json";
import navbar from "./navbar/navbar.json";
import personalManagement from "./cms/personal-management/personal-management.json";
import studentManagement from "./cms/manage-students/manage-students.json";
import onlineLeaveSubmission from "./cms/online-leave-submission/online-leave-submission.json";
import manageOnlineLeaveSubmission from "./cms/manage-online-leave-submission/manage-online-leave-submission.json";
import manageJobTitles from "./cms/manage-job-titles/manage-job-titles.json";
import organizationChartManagement from "./cms/organization-chart-management/organization-chart-management.json";
import courseManagement from './cms/course-management/course_management.json';
import courseOfStudy from './cms/course-of-study/course-of-study.json';
import eMeeting from './cms/e-meeting/e-meeting.json';
import complaints from './cms/complaints/complaints.json';
import homepage from "./home/homepage.json";

export const LocaleEn = {
  ...common,
  ...navbar,
  ...personalManagement,
  ...studentManagement,
  ...onlineLeaveSubmission,
  ...manageOnlineLeaveSubmission,
  ...manageJobTitles,
  ...organizationChartManagement,
  ...courseManagement,
  ...courseOfStudy,
  ...eMeeting,
  ...complaints,
  ...homepage
};
